import { OpexState } from "@/types/opex";

export function createOpexStateFromTemplateKpis(templateKpis: any): OpexState {
  const opex = templateKpis.opex || {};

  const getValue = (key: string, defaultValue: number) => {
    const value = opex[key];
    return value !== undefined && value !== null ? Number(value) : defaultValue;
  };

  return {
    items: [
      {
        id: "roomsCommission",
        label: "Rooms Commission",
        value: getValue("roomsCommission", 15),
        unit: "%",
        driver: "PCT_ROOMS_REVENUE",
        section: "DIRECT",
        tooltip: "Commission paid on room bookings",
        benchmark: { target: 15, min: 10, max: 20, unit: "%" },
      },
      {
        id: "guestSupplies",
        label: "Guest Supplies & Cleaning",
        value: getValue("guestSuppliesCleaning", 8),
        driver: "PER_ROOM_NIGHT_SOLD",
        section: "DIRECT",
        tooltip:
          "Cost of guest amenities and housekeeping supplies per occupied room",
        benchmark: { target: 8, min: 5, max: 12 },
      },
      {
        id: "cogs",
        label: "Cost of Goods Sold (F&B)",
        value: getValue("cogs", 30),
        unit: "%",
        driver: "PCT_FNB_REVENUE",
        section: "DIRECT",
        tooltip:
          "Cost of food and beverage inventory as percentage of F&B revenue",
        benchmark: { target: 30, min: 25, max: 35, unit: "%" },
      },
      {
        id: "meetingEvents",
        label: "Meeting & Events",
        value: getValue("meetingsEvents", 2),
        unit: "%",
        driver: "PCT_OTHER_REVENUE",
        section: "DIRECT",
        tooltip: "Meeting and events operational costs",
      },
      {
        id: "wellnessOther",
        label: "Wellness & Other",
        value: getValue("wellnessOther", 1500),
        driver: "FIXED_PER_MONTH",
        section: "DIRECT",
        tooltip: "Spa and wellness operational costs",
      },
      {
        id: "otherDirect",
        label: "Other Direct",
        value: getValue("otherDirect", 2000),
        driver: "FIXED_PER_MONTH",
        section: "DIRECT",
        tooltip: "Other departmental operational costs",
      },
      {
        id: "adminGeneral",
        label: "Admin & General Other",
        value: getValue("adminGeneralOther", 4),
        unit: "%",
        driver: "PCT_TOTAL_REVENUE",
        section: "INDIRECT",
        tooltip: "Administrative and general expenses",
        benchmark: { target: 4, min: 3, max: 5, unit: "%" },
      },
      {
        id: "techSubs",
        label: "Tech Subscriptions",
        value: getValue("techSubscriptions", 1200),
        driver: "FIXED_PER_MONTH",
        section: "INDIRECT",
        tooltip: "Monthly technology and software subscriptions",
      },
      {
        id: "salesMarketing",
        label: "Sales & Marketing Other",
        value: getValue("salesMarketingOther", 3),
        unit: "%",
        driver: "PCT_TOTAL_REVENUE",
        section: "INDIRECT",
        tooltip: "Sales and marketing expenses",
        benchmark: { target: 3, min: 2, max: 4, unit: "%" },
      },
      {
        id: "maintenance",
        label: "Maintenance Other",
        value: getValue("maintenanceOther", 2),
        unit: "%",
        driver: "PCT_TOTAL_REVENUE",
        section: "INDIRECT",
        tooltip: "Property maintenance and repairs",
        benchmark: { target: 2, min: 1.5, max: 3, unit: "%" },
      },
      {
        id: "utilities",
        label: "Utilities",
        value: getValue("utilities", 3),
        unit: "%",
        driver: "PCT_TOTAL_REVENUE",
        section: "INDIRECT",
        tooltip: "Electricity, water, gas, and other utilities",
        benchmark: { target: 3, min: 2, max: 4, unit: "%" },
      },
      {
        id: "mgmtFee",
        label: "Management Fee",
        value: getValue("mgmtFee", 3),
        unit: "%",
        driver: "PCT_TOTAL_REVENUE",
        section: "OTHER",
        tooltip: "Hotel management company fees",
        benchmark: { target: 3, min: 2, max: 4, unit: "%" },
      },
      {
        id: "propertyTaxes",
        label: "Property Taxes",
        value: getValue("propertyTaxes", 1),
        unit: "%",
        driver: "PCT_TOTAL_REVENUE",
        section: "OTHER",
        tooltip: "Annual property tax expenses",
      },
      {
        id: "insurance",
        label: "Insurance",
        value: getValue("insurance", 0.5),
        unit: "%",
        driver: "PCT_TOTAL_REVENUE",
        section: "OTHER",
        tooltip: "Property and liability insurance",
      },
      {
        id: "rent",
        label: "Rent",
        value: getValue("rent", 0),
        driver: "FIXED_PER_MONTH",
        section: "OTHER",
        tooltip: "Monthly lease or rental payments",
      },
    ],
  };
}
